import Swiper, { Pagination, Navigation } from 'swiper';
import { updateLazy } from '../functions/lazy';

import "../layouts/default";

import 'Ui/slider';

import '../common/social';
import '../common/lightgallery';

Swiper.use([Pagination, Navigation]);

document.addEventListener('DOMContentLoaded', function() {
    updateLazy();
});

const imageVideo = document.querySelector('.js-article-image-video')

if (imageVideo) {
    imageVideo.addEventListener('click', (event) => {
        const button = event.currentTarget
        const iframeEl = document.createElement('iframe')

        iframeEl.setAttribute('autoplay', 1)
        iframeEl.setAttribute('allowfullscreen', 1)
        iframeEl.setAttribute('frameborder', 0)
        iframeEl.setAttribute('src', button.dataset.src)
        iframeEl.classList.add('is-video')
        iframeEl.classList.add('is-active')

        button.parentNode.appendChild(iframeEl)
    })
}